import { Directive, ElementRef, Input, Output, EventEmitter, AfterViewInit, SimpleChanges, DoCheck } from '@angular/core';
import * as SelectFX from 'periodicjs.component.selectfx';
declare var $:any;

@Directive({
  selector: 'select.cs-select',
})
export class SelectStyleDirective implements AfterViewInit, DoCheck {
  private el: HTMLInputElement;
  private selectFx;

  @Input() value;
  @Output() onSelect:EventEmitter<any> = new EventEmitter();
  
  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.selectFx = new SelectFX(this.el, {
                                        onChange: value => {
                                          this.onSelect.emit(value);
                                          this.el.parentElement.classList.add("selected");
                                        }
                                      });
  }

  ngAfterViewInit(): void {
    this.setOption();  
  }

  // ngOnChanges(changes: SimpleChanges): void {
    // if (changes.value.currentValue !== changes.value.previousValue) {
    //   let placeholder = $(this.el.parentElement).children('span.cs-placeholder');
    //   if (placeholder.length <= 0) return;
    //   this.setOption();
    // }
  // }

  ngDoCheck(): void {
    if (this.value != this.selectFx.selectedOpt.value) {
      let placeholder = $(this.el.parentElement).children('span.cs-placeholder');
      if (placeholder.length <= 0) return;
      this.setOption();
    }
  }


  setOption() {
    if (!this.selectFx.selOpts || this.value == undefined) return;
    let find:boolean = false;

    for (let i = 0 ; i < this.selectFx.selOpts.length ; i++) {
      if (this.value && this.value === this.selectFx.selOpts[i].dataset.value) {
        this.selectFx.selOpts[i].classList.add('cs-selected');
        
        let placeholder = $(this.selectFx.selOpts[i]).text();
        $(this.selectFx.selPlaceholder).html(placeholder);

        this.el.parentElement.classList.add("selected");
        let options = $(this.el).children('option');

        for (let j = 0 ; j < options.length ; j++) {
          let option = $(options[j]);
          if (option.val() == this.value) {
            option.attr('selected', true);
            this.selectFx.selectedOpt = options[j];
          } else {
            option.attr('selected', false);
          }
        }
        find = true;
      } else {
        this.selectFx.selOpts[i].classList.remove('cs-selected');
      }

    }

    if (!find) {
      let options = $(this.el).children('option');
      this.selectFx.selectedOpt = options[0];
      let option = $(options[0]);
      let placeholder = option.text();
      option.attr('selected', true);

      $(this.selectFx.selPlaceholder).html(placeholder);
      this.el.parentElement.classList.remove("selected");
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/directives/select.ts